export default ({ message, secondaryMessage, type }) => dispatch => {
    dispatch({
        type: 'SHOW_SNACKBAR_MESSAGE',
        payload: { message, type, secondaryMessage }
    })
}